<template>
  <div v-if="cur_group.name !== undefined" class="device-group__config">

    <div class="device-group__config-info">
      <div class="header" v-if="!hidden_items">
        <fg-input
          v-model="cur_group.name"
          class="name"
          type="text"
          placeholder="name group"
          :label="translate('group.name')"
          :readonly="!$store.getters.getPermissions.editDeviceGroups === true"
        />
        <button
          v-if="$store.getters.getPermissions.editDeviceGroups === true"
          class="mdi mdi-content-save btn btn-success"
          @click.prevent="save_group"
          :disabled="check_change"
        >
          <b>{{translate('config.save')}}</b>
        </button>

        <router-link
          class="mdi mdi-eye btn btn-success"
          :to="open_device_group(group.id)"
        >
          <b>{{translate('config.show_group_devices')}}</b>
        </router-link>
      </div>

      <div class="main_block" v-if="!hidden_items">
        <div class="row">
          <div class="form-group col-md-6">
            <label>
              {{translate('device.config.client')}}
            </label>
            <tree-select
                v-model="cur_group.client_id"
                :options="client_list"
                :placeholder="translate('device.config.client')"
                :disabled="!$store.getters.getPermissions.editDeviceGroups === true"
                :clearable="false"
            />
          </div>

          <fg-input
              v-model="cur_group.user_name"
              class="name col-md-6"
              type="text"
              :label="translate('device.config.user')"
              :placeholder="translate('device.config.user')"
              :readonly="true"
          />
        </div>

        <div class="row">
          <fg-input
              v-model="created"
              class="name col-md-6"
              type="text"
              :label="translate('device.config.created')"
              :placeholder="translate('device.config.created')"
              :readonly="true"
          />
          <fg-input
              v-model="updated"
              class="name col-md-6"
              type="text"
              :label="translate('device.config.updated')"
              :placeholder="translate('device.config.updated')"
              :readonly="true"
          />
        </div>
      </div>

      <div class="main_block" v-if="$store.getters.getPermissions.editDeviceGroupConfig === true">
        <button class="btn btn-success btn-fill" @click.prevent="open_modal_config()">
          {{ check_config ? translate('device.config.open_group_config') : translate('device.config.create_group_config')}}
        </button>
      </div>

      <div class="response_table" v-if="users_list.length > 0 && $store.getters.getPermissions.permissionGod === true">
        <div class="table_header">
          <label class="title">{{ translate('user.many') }}</label>
        </div>

        <table >
          <thead style="flex: 0">
            <tr>
              <th scope="col">
                User
              </th>
              <th scope="col">
                Client
              </th>
            </tr>
          </thead>

          <tbody>

            <tr v-for="(user, index) in users_list" :key="index">
              <td data-label="User">
                <router-link :to="{path: '/user/' + user.id}" class="link">
                  <span> {{ user.username }} </span>
                </router-link>
              </td>

              <td data-label="Client">
                <router-link :to="{path: '/client/' + user.client_id}" class="link">
                  <span> {{ user.client_name }} </span>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>

    <div v-if="cnt_mul !== 0" class="device-group__config-multi_instance">
      <div
        v-for="(value, key) in config.multi_instance"
        :key="key"
        class="device-group__config-multi_instance-item"
      >
        <span>
          Multi Link {{ key }}:
          <span class="mdi mdi-delete" @click="delete_multi(key)"/>
        </span>
        <textarea v-model="config.multi_instance[value]"/>
      </div>
    </div>
  </div>
</template>

<script>
import ModalConfig from '../Modal/Config.vue'
import SisIconStatus from "components/UIComponents/Icon/SisIconStatus.vue";

export default {
  name: 'DeviceGroupInfo',
  components: {
    SisIconStatus
  },
  props: ['group'],
  data () {
    return {
      config_data: {
        config : {
          multi_instance: {},
        }
      },
      cur_group: {
        // id: null,
        // client_id: null,
        // client_name: null,
        // config_data: {},
        // config_default: null,
        // name: null,
        // parent: null,
        // ts_create: null,
        // ts_update: null,
        // user_name: null,
      },
      users_list: {}
    }
  },
  computed: {
    check_config(){
      let keys = Object.keys(this.config_data)
      return keys.indexOf("create_user_id") > -1 && keys.indexOf("ts_create") > -1
    },
    cnt_mul () {
      return Object.keys(this.config_data.config.multi_instance).length
    },
    created(){
      return this.get_date(this.cur_group.ts_create)
    },
    updated(){
      return this.get_date(this.cur_group.ts_update)
    },
    client_list(){
      return this.$store.getters.getClientsList.map(client => {
        return {id: client.id, label: client.name }
      })
    },
    check_change(){
      return !(((this.group.client_id !== this.cur_group.client_id) && (this.cur_group.client_id !== '')) || this.group.name !== this.cur_group.name)
    },
    hidden_items(){
      return this.cur_group.id === 0
    }
  },
  watch: {
    group () {
      if (this.group?.id > 0) {
        this.cur_group = JSON.parse(JSON.stringify({
          ...this.cur_group,
          ...this.group
        }))

        if (this.$store.getters.getPermissions.editDeviceGroupConfig === true){
          this.$http.v1.getInfoDeviceGroup(this.group.id, (response) => {
            this.cur_group = { ...this.cur_group, ...response.data }
            // this.$set(this.cur_group, "ts_create", response.data.ts_create)

            this.config_data = response.data.config_data
            this.users_list = response.data.users
            if (Array.isArray(this.config_data.config.multi_instance)) {
              this.config_data.config.multi_instance = {}
            }
          })
        }
      }else{
        this.cur_group = {}
      }
    }
  },
  methods: {
    open_modal_config(){
      let t = this.$createElement(ModalConfig,{
        props: {
          group: this.group,
          config: this.config_data
        },
        on: {
          close: () => {
            this.$modal.hide('modal-config')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'modal-config'
      })
    },
    save_group () {
      this.$http.v1.updateGroup({...this.cur_group},() => {
        this.global_notify('info', this.translate('group.updated'))
        this.$store.dispatch('deviceGroupUpdate')
        this.$emit('clear')
      })
    },
    open_device_group(id){
      return {path: '/device_list?group=' + id}
    },

    delete_multi (key) {
      if (confirm('Действительно удалить Multi Link ' + key + '?')) {
        delete this.config_data.config.multi_instance[key]
        let cnt = 0
        let multi = {}
        for (let i in this.config_data.config.multi_instance) {
          multi['multi_link_' + (++cnt)] = this.config_data.config.multi_instance[i]
        }
        this.config_data.config.multi_instance = multi

        this.config_data = {...this.config_data}
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .device-group{
    &__config{
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      padding: 10px;
      &-info{
        margin-bottom: 10px;
        .header{
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          flex-wrap: wrap;
          .name{
            width: 50%;
            margin-bottom: 0;
          }
          .btn{
            padding: 7px;
            height: 40px;
            width: 24%;
          }
        }
        .main_block{
          opacity: 1;
          transition: 0.3s;
          padding: 5px 0;
          &.-hide{
            height: 0;
            opacity: 0;
          }
          .btn{
            width: 100%;
          }
        }
        .response_table{
          padding: 0;
          margin-top: 20px;
          height: 515px;
          table{
            height: calc(100% - 25px);
          }
          th.delete{
            width: 50px;
          }
          td.delete{
            width: 50px;
            cursor: pointer;
            .red{
              color: #EB5E28;
            }
          }
        }
      }
      &-multi_instance{
        flex: 10;
        width: 100%;
        height: 100%;
        overflow: auto;
        &-item{
          flex: 2;
          display: flex;
          flex-direction: column;
          padding: 0 5px;
          textarea{
            width: 100%;
            overflow: auto;
            min-height: 200px;
            flex:2;
          }
        }
      }
    }
  }

  @media (max-width:1560px) {
    .device-group{
      &__config{
        &-info{
          .header{
            .name{
              width: 100%;
              margin-bottom: 10px;
            }
            .btn{
              width: 49%;
            }
          }
        }
      }
    }
  }

  @media (max-width:768px) {
    .device-group{
      &__config{
        padding: 10px 0;
        overflow: auto;
        &-info{
          .header{
            .name{
              width: 70%;
              margin-bottom: 0;
            }
            .btn{
              width: 13%;
              padding: 7px;
              b{
                display: none;
              }
            }
          }
        }
        &-multi_instance{
          overflow: visible;
        }
      }
    }
  }
</style>
